/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbSyncLogListRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbSyncLogListRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbSyncLogListRequest>): ServiceNowCmdbSyncLogListRequest {
        let obj = Object.assign(new ServiceNowCmdbSyncLogListRequest(), model);
        ServiceNowCmdbSyncLogListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbSyncLogListRequest>): ServiceNowCmdbSyncLogListRequest {
        if (!model) return null;
        return ServiceNowCmdbSyncLogListRequest.newInstance(<ServiceNowCmdbSyncLogListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbSyncLogListRequest) {
        if (!obj) return;

        models.ServiceNowCmdbSyncLogListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbSyncLogListRequest): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbSyncLogListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ServiceNowCmdbSyncLogFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ServiceNowCmdbSyncLogSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ServiceNowCmdbSyncLogSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ServiceNowCmdbSyncLogFilters;

}
